import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"
import cx from "classnames"
import history from "app/history"
import { PageLoader } from "components/common/Loader"
import Footer from "components/footer"
import ResponseModal from "components/common/ResponseModal"
import { getSchoolDetailsByDomain, closeForumModal } from "store/school/actions"
import {
  closeResponseModal,
  startCourse,
  closeConfirmModal,
} from "store/user/actions"
import { resendEmail } from "store/auth/action"
import { SOCIALS } from "constants/socials"
import ForumModal from "components/forums/ForumModal"
import ConfirmModal from "components/common/ConfirmModal"
import { SUBSTITUTE_DOMAINS, GOOGLE_SITE_KEY } from "constants/config"
import IdleChecker from "../idle-checker"

class PageContainer extends React.Component {
  componentDidMount() {
    const {
      school: { schoolData },
      getSchoolDetailsByDomain,
    } = this.props

    if (isEmpty(schoolData)) {
      const domains = window.location.hostname.split(".")
      const subdomain = domains[0]
      const substituteDomain = SUBSTITUTE_DOMAINS[subdomain]

      if (substituteDomain) {
        getSchoolDetailsByDomain(substituteDomain)
      } else {
        getSchoolDetailsByDomain(subdomain)
      }
    }
  }

  handleResendEmail = () => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(GOOGLE_SITE_KEY, { action: "submit" })
        .then((token) => {
          this.props.resendEmail({
            "g-recaptcha-response": token,
          })
        })
    })
  }

  handleAction = () => {
    const {
      user: { responseModal },
      closeResponseModal,
      courses: { selectedCourse },
      startCourse,
    } = this.props
    if (responseModal?.actionLabel?.toUpperCase() === "VIEW CERTIFICATE") {
      closeResponseModal()
      history.push("/student/certificates")
    } else if (!responseModal.action && !responseModal.verified) {
      closeResponseModal()
      this.handleResendEmail()
    } else if (
      !responseModal.action &&
      responseModal.actionLabel === "START LEARNING"
    ) {
      closeResponseModal()
      startCourse({ id: selectedCourse.id })
    } else {
      closeResponseModal()
      if (responseModal.action) {
        responseModal.action()
      }
    }
  }

  handleConfirmAction = () => {
    const {
      user: { confirmModal },
      closeConfirmModal,
    } = this.props

    closeConfirmModal()

    if (confirmModal.confirmAction) {
      confirmModal.confirmAction()
    }
  }

  render() {
    const {
      children,
      withoutFooter,
      school: { isLoading, schoolData, socials, forumModal },
      isPageLoading,
      className,
      user: { responseModal, confirmModal },
      closeResponseModal,
      closeForumModal,
      closeConfirmModal,
      auth: { isAuthorized },
    } = this.props

    var socialMediaLinks = []

    if (!isEmpty(socials)) {
      SOCIALS.map((SOCIAL) => {
        Object.keys(socials).forEach((item) => {
          if (SOCIAL.label === item) {
            SOCIAL.url = socials[item]
          }
        })
        socialMediaLinks.push(SOCIAL)
        return socialMediaLinks
      })
    }

    const withIdleWarningModal =
      schoolData?.config?.products?.idle_timeout_mins > 0

    return (
      <div className={cx(className)}>
        <PageLoader loading={isLoading || isPageLoading} />
        {children}
        {withoutFooter ? null : (
          <Footer data={schoolData} socials={socialMediaLinks} />
        )}
        <ResponseModal
          isOpen={responseModal.showResponseModal}
          modalContent={responseModal}
          closeModal={() => closeResponseModal()}
          modalAction={() => this.handleAction()}
        />
        <ForumModal
          modalType={forumModal.type}
          isEdit={forumModal.isEdit}
          isOpen={forumModal.showModal}
          closeModal={() => closeForumModal()}
        />
        <ConfirmModal
          modalType={confirmModal.type}
          isEdit={confirmModal.isEdit}
          isOpen={confirmModal.showModal}
          modalContent={confirmModal}
          closeModal={() => closeConfirmModal()}
          onConfirm={() => this.handleConfirmAction()}
          onCancel={confirmModal.cancelAction}
        />
        {isAuthorized && withIdleWarningModal && <IdleChecker />}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  landing: state.landingReducer,
  user: state.userReducer,
  courses: state.coursesReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSchoolDetailsByDomain,
      closeResponseModal,
      resendEmail,
      startCourse,
      closeForumModal,
      closeConfirmModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  PageContainer
)
